/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Output_Language_LabelInputs */

const en_output_language_label = /** @type {(inputs: Output_Language_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Output Language`)
};

const de_output_language_label = /** @type {(inputs: Output_Language_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ausgabesprache`)
};

const fr_output_language_label = /** @type {(inputs: Output_Language_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Langue de sortie`)
};

const es_output_language_label = /** @type {(inputs: Output_Language_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Idioma de salida`)
};

const it_output_language_label = /** @type {(inputs: Output_Language_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lingua di output`)
};

const nl_output_language_label = /** @type {(inputs: Output_Language_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uitvoertaal`)
};

const pl_output_language_label = /** @type {(inputs: Output_Language_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jezyk wyjsciowy`)
};

const fi_output_language_label = /** @type {(inputs: Output_Language_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tulostuskieli`)
};

const da_output_language_label = /** @type {(inputs: Output_Language_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Outputsprog`)
};

const sv_output_language_label = /** @type {(inputs: Output_Language_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Utsprak`)
};

/**
* | output |
* | --- |
* | "Output Language" |
*
* @param {Output_Language_LabelInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const output_language_label = /** @type {((inputs?: Output_Language_LabelInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Output_Language_LabelInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_output_language_label(inputs)
	if (locale === "fr") return fr_output_language_label(inputs)
	if (locale === "es") return es_output_language_label(inputs)
	if (locale === "it") return it_output_language_label(inputs)
	if (locale === "nl") return nl_output_language_label(inputs)
	if (locale === "pl") return pl_output_language_label(inputs)
	if (locale === "fi") return fi_output_language_label(inputs)
	if (locale === "da") return da_output_language_label(inputs)
	if (locale === "sv") return sv_output_language_label(inputs)
	return en_output_language_label(inputs)
});